import React from "react";

import { CommLogPanelContext } from "../context/CommLogPanelContext";

import CommLogError from "./CommLogError";
import CommLogFilters from "./CommLogFilters";
import CommLogHeader from "./CommLogHeader";
import CommLogList from "./CommLogList";
import CommLogPagination from "./CommLogPagination";
import CommLogSearch from "./CommLogSearch";

export default function CommLogPanel({ children }) {
  return (
    <CommLogPanelContext.Provider value={{}}>
      <div
        id="Log-Panel"
        data-testid="Log-Panel"
        className="rounded-md border-y border-gray-100 bg-white px-0"
      >
        {React.Children.map(children, (child) => React.cloneElement(child))}
      </div>
    </CommLogPanelContext.Provider>
  );
}

CommLogPanel.Header = CommLogHeader;
CommLogPanel.List = CommLogList;
CommLogPanel.Search = CommLogSearch;
CommLogPanel.Pagination = CommLogPagination;
CommLogPanel.Error = CommLogError;
CommLogPanel.Filters = CommLogFilters;
